import { jsx } from "react/jsx-runtime";
import CircleIcon from "@mui/icons-material/Circle";
import { validateTidalLicense } from "../../base/index.js";
function Circle(props) {
  return /* @__PURE__ */ jsx(
    CircleIcon,
    {
      "data-testid": "Circle",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Circle",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
Circle.tidalIconMeta = {
  categories: "miscellaneous",
  name: "Circle"
};
validateTidalLicense();
export {
  Circle
};
//# sourceMappingURL=Circle.js.map
